module.exports = __webpack_public_path__ + "img/tygd (2).f94ec3ef.png";